export default async (files) => {
  const promises = [];
  for (let index = 0; index < files.length; index++) {
    const file = files[index];
    const promise = new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        file.durationInSeconds = Math.floor(video.duration);
        resolve(file);
      };

      video.src = URL.createObjectURL(file);
    }).catch(() => {});

    promises.push(promise);
  }
  return await Promise.all(promises);
};
